t = require('app/scripts/views/internal/teacup-with-helpers')('cant_add_board_to_org')

module.exports = ->
  t.p '.quiet', ->
    t.mustacheBlock 'isOrgAdmin', ->
      t.format 'organization-displayname-does-not-allow-new-boards-you-can-change-this-on-the-organization-settings-page-by-clicking-on-board-creation-restrictions', { 'organization.displayName': t.mustacheVar('organization.displayName'), orgSettingsUrl: t.mustacheVar('orgSettingsUrl') }
    t.mustacheBlockInverted 'isOrgAdmin', ->
      t.format 'organization-displayname-does-not-allow-new-boards-only-an-admin-of-the-organization-can-change-this-setting', { 'organization.displayName': t.mustacheVar('organization.displayName') }
